import React from 'react';

import CompaniesPage from '../components/CompaniesPage';

const Companies = () => (
  <CompaniesPage
    lang="zh"
    title="合作伙伴 | 全栈公开课"
    seoDescription="合作伙伴中的全栈工程师"
  />
);

export default Companies;
